// =============================================================================
// DEAL TYPE BADGE - Uses centralized registry (CR043)
// =============================================================================

import { cn } from "@/lib/utils";
import { 
  type DealCategory, 
  getDealCategoryLabel, 
  getDealCategoryColor,
  getDealCategoryIcon,
  badgeStyles,
  getBadgeSizeClasses
} from "@/lib/deals";

interface DealTypeBadgeProps {
  category: DealCategory;
  size?: "sm" | "md";
  className?: string;
}

export function DealTypeBadge({ category, size = "sm", className }: DealTypeBadgeProps) {
  const label = getDealCategoryLabel(category);
  const colors = getDealCategoryColor(category);
  const Icon = getDealCategoryIcon(category);
  const sizeClasses = getBadgeSizeClasses(size);
  
  return (
    <span 
      className={cn(
        badgeStyles.base,
        colors.bg,
        colors.text,
        colors.border,
        sizeClasses.container,
        className
      )}
    >
      <Icon className={sizeClasses.icon} />
      {label}
    </span>
  );
}